/**
 * Translation registry — lazily loaded so non-English tables stay out of the
 * initial bundle (fr.ts is ~43KB of source that most sessions never need).
 *
 * To add a new language:
 * 1. Create a new file (e.g. es.ts) matching the shape of fr.ts
 * 2. Add a loader for it to the `loaders` map below
 * @module translations
 */

import type { fr } from "./fr.js";

/** The shape every language file must satisfy. */
export type TranslationSet = typeof fr;

/**
 * Loaded translations keyed by locale code. Starts empty; the string getters
 * fall back to English until `loadTranslations` has resolved for a locale.
 * English is the built-in fallback and is never listed here.
 */
export const translations: Record<string, TranslationSet> = {};

const loaders: Record<string, () => Promise<TranslationSet>> = {
	fr: () => import("./fr.js").then((m) => m.fr),
};

/** Idempotent: resolves immediately for English or already-loaded locales. */
export async function loadTranslations(locale: string): Promise<void> {
	const loader = loaders[locale];
	if (locale === "en" || translations[locale] || !loader) return;
	translations[locale] = await loader();
}
